import { render, staticRenderFns } from "./VideoMixins.vue?vue&type=template&id=a4bbd780&"
import script from "./VideoMixins.vue?vue&type=script&lang=js&"
export * from "./VideoMixins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports